import { UpdateOrderPriceForm, EUpdateOrderPriceOption } from '@/@types/order';
import usePharmacyQuery from '@/hooks/pharmacy/usePharmacyQuery';
import { useState } from 'react';

const UPDATE_ORDER_PRICE_OPTIONS = [
  {
    label: '가격 오기입으로 인한 결제 금액 변경',
    value: EUpdateOrderPriceOption.WRONG_PRICE
  },
  {
    label: '처방전 수정으로 인한 결제 금액 변경',
    value: EUpdateOrderPriceOption.PRESCRIPTION_CHANGE
  },
  { label: '직접 입력', value: EUpdateOrderPriceOption.MANUAL }
];

interface Props {
  orderId: number;
  onCloseModal: () => void;
}

const useUpdateOrderPriceFormViewModel = ({
  orderId,
  onCloseModal
}: Props) => {
  const [form, setForm] = useState<UpdateOrderPriceForm>({
    orderId,
    reason: EUpdateOrderPriceOption.WRONG_PRICE,
    price: undefined,
    reasonType: EUpdateOrderPriceOption.WRONG_PRICE
  });

  const {
    orderPriceUpdateMutation: { mutateAsync }
  } = usePharmacyQuery();

  const isManualReasonSelected = () => {
    return Boolean(form.reasonType === EUpdateOrderPriceOption.MANUAL);
  };

  const changeReason = (reasonType: EUpdateOrderPriceOption) => {
    setForm(form => ({
      ...form,
      reasonType,
      reason:
        reasonType === EUpdateOrderPriceOption.MANUAL
          ? undefined
          : UPDATE_ORDER_PRICE_OPTIONS.find(
              option => option.value === reasonType
            )?.label
    }));
  };

  const onChangeInputReason = (input: string) => {
    setForm(form => ({
      ...form,
      reason: input
    }));
  };

  const onClearReason = () => {
    setForm(form => ({
      ...form,
      reason: undefined
    }));
  };

  const onChangeInputPrice = (input: string) => {
    const numberOnlyInput = input.replace(/\D/g, '');
    setForm(form => ({
      ...form,
      price: numberOnlyInput
    }));
  };

  const onSubmit = async () => {
    try {
      if (!form.price || !form.reason || !form.orderId) {
        throw new Error('입력 값을 확인해주세요.');
      }

      await mutateAsync({
        price: String(form.price),
        reason: form.reason ?? '약국 사정으로 결제 금액이 변경되었어요',
        orderId: String(form.orderId)
      });
      onCloseModal();
    } catch (error) {
      alert((error as Error).message);
    }
  };
  return {
    onChangeInputReason,
    onChangeInputPrice,
    changeReason,
    onClearReason,
    onSubmit,
    selectOptions: UPDATE_ORDER_PRICE_OPTIONS,
    form,
    isManualReasonSelected
  };
};

export default useUpdateOrderPriceFormViewModel;
